import React, { useContext, useState } from 'react'
import { CreationToolsArtboardContext } from '../context'
import Draggable from '../draggable'
import { ArtboardBaseLayerProps, ArtboardCornerPosition, ArtboardDragPosition } from '../types'

interface Props extends ArtboardBaseLayerProps {
    frame: HTMLCanvasElement | HTMLImageElement
    width: number
    height: number
    transformOrigin?: ArtboardCornerPosition
    forceSelected?: boolean
    onMove?: (position: ArtboardDragPosition) => void
}

const CreationToolsArtboardLayer = ({
    defaultX,
    defaultY,
    defaultRotation = 0,
    transformOrigin,
    width,
    height,
    moveable = false,
    rotateable = false,
    resizeable = false,
    forceSelected = false,
    frame,
    onMove,
}: Props) => {
    const { renderingContext, canvasScale } = useContext(CreationToolsArtboardContext)
    const [position, setPosition] = useState<ArtboardDragPosition>()

    const onDragUpdate = (position: ArtboardDragPosition) => {
        setPosition(position)
        onMove && onMove(position)
    }

    // render frame
    if (renderingContext && position) {
        const { x, y, rotation, scaleX, scaleY } = position
        const frameWidth = width * canvasScale * scaleX
        const frameHeight = height * canvasScale * scaleY

        renderingContext.save()
        renderingContext.translate(x * canvasScale, y * canvasScale)
        renderingContext.rotate(rotation * (Math.PI / 180))
        renderingContext.drawImage(frame, -frameWidth / 2, -frameHeight / 2, frameWidth, frameHeight)
        renderingContext.restore()
    }

    return (
        <Draggable
            {...{
                defaultX,
                defaultY,
                defaultRotation,
                transformOrigin,
                width,
                height,
                moveable,
                rotateable,
                resizeable,
                forceSelected,
                onUpdate: onDragUpdate,
            }}
        />
    )
}

export default CreationToolsArtboardLayer
